import { Button } from "@material-ui/core";
import React from 'react';
import { useSelector } from "react-redux";
import { useHistory } from "react-router";
import { hasPermissionForAccount } from "src/Utility/PermissionsUtil";

const InternalBilateralAppBar = () => {

    const chosenAccount = useSelector(state => state.chosenAccount.account);
    const roles = useSelector(state => state.auth.roles);
    const history = useHistory();

    const buildViewContractsMenu = () => {
        if (hasPermissionForAccount(roles, chosenAccount.id, "ROLE_retrieve_inschedule_contract")) {
            return (<Button onClick={() => history.push("/internal-bilaterals/account/" + chosenAccount.id + "/contract")}>Contracts</Button>);
        }
    }

    const buildCreateScheduleMenu = () => {
        if (hasPermissionForAccount(roles, chosenAccount.id, "ROLE_create_inschedule_schedule")) {
            return (<Button onClick={() => history.push("/internal-bilaterals/account/" + chosenAccount.id + "/contract/schedules/create")}>Create Schedules</Button>);
        }
    }

    const buildNotificationMenu = () => {
        if (hasPermissionForAccount(roles, chosenAccount.id, "ROLE_create_inschedule_notification") || hasPermissionForAccount(roles, chosenAccount.id, "ROLE_retrieve_inschedule_notification")) {
            return (<Button onClick={() => history.push("/internal-bilaterals/account/" + chosenAccount.id + "/notifications")}>Notifications</Button>);
        }
    }

    return (
        <React.Fragment>
            {buildViewContractsMenu()}
            {buildCreateScheduleMenu()}
            {buildNotificationMenu()}
        </React.Fragment>
    )

}

export default InternalBilateralAppBar;